import { useNavigate } from '@tanstack/react-router';

import { useEstimationQueryActions } from '@/api/hooks/estimationQueryActions';
import RoundArrowRightIcon from '@/assets/round-arrow-right-icon.svg?react';
import { Button } from '@/components/atoms/Button';
import { useMessages } from '@/hooks/messages';

import { eEstimationDetailTab } from '../model';
import { estimationStartReviewButtonMessageDefinitions } from './messages';

interface StartReviewButtonProps {
  estimationId: string;
}

export const StartReviewButton: FC<StartReviewButtonProps> = ({ estimationId }) => {
  const messages = useMessages(estimationStartReviewButtonMessageDefinitions);
  const navigate = useNavigate();

  const { useStartEstimationReview } = useEstimationQueryActions();
  const startReviewMutation = useStartEstimationReview();

  return (
    <Button
      data-testid='start-review-button'
      variant='primary'
      IconComponentRight={RoundArrowRightIcon}
      onClick={async () => {
        await startReviewMutation.mutateAsync({ estimationId });
        await navigate({
          to: '/estimation/detail/$estimationId/$tabId',
          params: { estimationId, tabId: eEstimationDetailTab.review },
        });
      }}
    >
      {messages.startReviewButton()}
    </Button>
  );
};
